export const tr = {
    choose: 'Seç'
};
